import { render, staticRenderFns } from "./SubmitSuccess.vue?vue&type=template&id=792c0a38&scoped=true&"
var script = {}
import style0 from "./SubmitSuccess.vue?vue&type=style&index=0&id=792c0a38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "792c0a38",
  null
  
)

export default component.exports